export default "__VITE_ASSET__43076eb7__"